import React, { useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { App as AntApp } from "antd";
import { tokenStorage, SESSION_EXPIRED_EVENT } from "./http.js";

function safePath(currentPath) {
  if (!currentPath || currentPath.startsWith("/signin")) return "/signin";
  return currentPath;
}

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { message } = AntApp.useApp();
  const toastedRef = useRef(false);

  // Surface a friendly notice when the http interceptor forced a logout
  // (refresh-token round-trip failed). We toast once per mount.
  useEffect(() => {
    const handler = () => {
      if (toastedRef.current) return;
      toastedRef.current = true;
      message.warning({
        content: "Your session has expired. Please sign in again.",
        duration: 3,
      });
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, handler);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
  }, [message]);

  const token = tokenStorage.getAccess();
  if (!token) {
    return (
      <Navigate to="/signin" state={{ from: safePath(location.pathname) }} replace />
    );
  }
  return children;
};

export default PrivateRoute;
